import { Component, AfterViewInit, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { DashboardService } from "../Service/Dashboard.Service";
import { AppointmentsService } from "../../Appointments/service/Appointments.Service";
import { LoginModel, DashboardDataContainer, UserData, AppointmentDataModel, LabDataModel } from "../../model/index"
import { Title } from '@angular/platform-browser';
import { SecurityService } from '../../Security/security.service';
import { Router } from "@angular/router";
import { ModalComponent } from "../../shared/modeldialog/index";
import { NavigationMenu } from "../../model/index";

declare var require: any;
@Component({
    selector: 'MentisSoft-Dashboard',
    template: require('../Template/Dashboard.template.html'),
    styles: [require('../Template/Dashboard.css')],
    providers: [AppointmentsService],
    encapsulation: ViewEncapsulation.None
})

export class DashboardComponent implements AfterViewInit {
    [x: string]: any;
    Querynumber: string;
    navigation: NavigationMenu = new NavigationMenu();
    IsInsuranceVisible: boolean = false;
    IsServiceVisible: boolean = false;
    IsAppointmentVisible: boolean = false;
    IsAdvanceVisible: boolean = false;
    IsAllergyVisible: boolean = false;
    IsScheduleVisible: boolean = false;
    IsRadiologyVisible: boolean = false;
    IsLabVisible: boolean = false;
    IsImmunizationVisible: boolean = false;
    IsMedicationVisible: boolean = false;
    IsDocuments: boolean = false;
    IsProcedureVisible: boolean = false;
    IsRoleId: boolean = false;
    showUpcomingAppointments: boolean = false;
    showLabResults: boolean = false;
    showRecentPromo: boolean = false;
    constructor( @Inject(SecurityService) private _SecurityService: SecurityService, private _appointmentService: AppointmentsService, private _dashboardService: DashboardService, private _titleService: Title, private router: Router) {
        if (window.innerWidth < 768) {
            this.showUpcomingAppointments = false;
            this.showLabResults = false;
        }  else {
            this.showUpcomingAppointments = true;
            this.showLabResults = true;
        }
        this.userData.pid = _SecurityService.pid;

        this.Querynumber = router.parseUrl(router.url).queryParams["Id"];

        if (this.Querynumber == "" || this.Querynumber == undefined) {
            this.Querynumber = this.router.parseUrl(this.router.url).queryParams["result"];
        }
    };
    PaylaterStatus: string = "";
    reportsLength: number;
    recentAppIndex: number = 0;
    totalrecentApplength: number = 0;
    tab: string;
    loading = false;
    message: string;
    patientId: string = "";
    patientName: string = "";
    IsPatientSearch: boolean = false;
    errMsg: string = "";
    IsBookingConfirmed: boolean;
    dashboardReports: DashboardDataContainer = new DashboardDataContainer();
    userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
    appointmentsFiltered: AppointmentDataModel[] = [];
    columns: any[] = [];
    dataSource: LabDataModel[] = [];
    @ViewChild("viewModelPopup") viewModelPopup: ModalComponent;
    @ViewChild("payNowBookingPopup") payNowBookingPopup: ModalComponent;
    IsAdminUser: boolean = false;
    HospitalName: string = "";
    Hospital: string = "";

    ScannedValue: string = "";
    HOSPITALNO: string = "";
    FULLNAME: string = "";
    APPOINTMENTDATE: string = "";
    DOCTORNAME: string = "";
    RECEIPTNO: string = "";
    TRANSACTIONID: string = "";
    AMOUNT: string = "";
    PAIDSTATUS: string = "";
    DOCUMENTFLAG: string = "";
    ngAfterViewInit(): void {
        this.LoadMenusVisibility();
        this.IsAdminUser = JSON.parse(localStorage.getItem("ISAdmin"));
        this.Hospital = localStorage.getItem("HospitalName");
        if (this.Hospital == "BSH")
            this.HospitalName = "FALSE";
        else
            this.HospitalName = "TRUE";

        if (this.IsAdminUser == true) {
            if (localStorage.getItem("AdminPatientId") != undefined || localStorage.getItem("AdminPatientId") != null)
                this.patientId = localStorage.getItem("AdminPatientId");
            if (localStorage.getItem("AdminPatientName") != undefined || localStorage.getItem("AdminPatientName") != null)
                this.patientName = localStorage.getItem("AdminPatientName");
        }
        $('#overlay').hide();
        this._titleService.setTitle("Dashboard Reports");
        if (this.Querynumber != "" && this.Querynumber != undefined) {
            if (this.IsAdminUser == true) {
                this.patientId = this.Querynumber;
            }
            this.LoadingAfterPayment(this.Querynumber);
        }
        this.getDashboardReports();


    }

    GetScannedDetails() {
        this.HOSPITALNO = "";
        this.FULLNAME = "";
        this.PAIDSTATUS = "";
        this.DOCUMENTFLAG = "";
        document.getElementById("QrScanner").setAttribute("style", "display: none;");
        if (localStorage.getItem("QRCODE") != undefined && localStorage.getItem("QRCODE") != null && localStorage.getItem("QRCODE") != "") {
            this.ScannedValue = localStorage.getItem("QRCODE");
        }
        this.GetScanDetails(this.ScannedValue);
    }
    EnableScan() {
        this.HOSPITALNO = "";
        this.FULLNAME = "";
        this.PAIDSTATUS = "";
        this.DOCUMENTFLAG = "";
        this.APPOINTMENTDATE = "";
        this.DOCTORNAME = "";
        this.RECEIPTNO = "";
        this.TRANSACTIONID = "";
        this.AMOUNT = "";
        document.getElementById("QrScanner").setAttribute("style", "display: inline;");
    }
    CancelScan() {
        localStorage.setItem("QRCODE", "");
        this.HOSPITALNO = "";
        this.FULLNAME = "";
        this.PAIDSTATUS = "";
        this.DOCUMENTFLAG = "";
        this.APPOINTMENTDATE = "";
        this.DOCTORNAME = "";
        this.RECEIPTNO = "";
        this.TRANSACTIONID = "";
        this.AMOUNT = "";
        this.ScannedValue = "";
        document.getElementById("QrScanner").setAttribute("style", "display: none;");
        console.log(this.router.url);
        window.location.href = this.router.url;
    }
    GetScanDetails(InvoiceId: string) {
        this._dashboardService.getScannerDetails(this.userData.User, this.userData.Authentication, InvoiceId, this.userData.IsAdminUser)
            .subscribe(
                p => {
                    if (p != null) {
                        this.HOSPITALNO = p[0].HOSPITALNO;
                        this.FULLNAME = p[0].FULLNAME;
                        this.APPOINTMENTDATE = p[0].APPOINTMENTDATE;
                        this.DOCTORNAME = p[0].DOCTORNAME;
                        this.RECEIPTNO = p[0].RECEIPTNO;
                        this.TRANSACTIONID = p[0].TRANSACTIONID;
                        this.AMOUNT = p[0].AMOUNT;
                        this.PAIDSTATUS = p[0].PAIDSTATUS;
                        this.DOCUMENTFLAG = p[0].DOCUMENTFLAG;
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting data...");
                });
    }

    navigate() {
        this.router.navigate(["/Lab"]);
    }

    toggleLabResults() {
        this.showLabResults = !this.showLabResults;
        if (this.showLabResults) {
            this.showUpcomingAppointments = false;
            this.showRecentPromo = false;
           
    }
    }

    toggleUpcomingAppointmentsResults() {
        this.showUpcomingAppointments = !this.showUpcomingAppointments;
        if (this.showUpcomingAppointments) {
            this.showLabResults = false;
            this.showRecentPromo = false;

        }
    }

    toggleRecent() {
        this.showRecentPromo = !this.showRecentPromo;
        if (this.showRecentPromo) {
            this.showLabResults = false;
            this.showUpcomingAppointments = false;

        }
    }


    navigateToUrl(value) {
        window.open(value, '_blank');
    }

    getPrevAppointments() {
        this.recentAppIndex = this.recentAppIndex - 2;
        if (this.recentAppIndex >= 0) {
            this.appointmentsFiltered = this.dashboardReports.appointments.slice(this.recentAppIndex, this.recentAppIndex + 2);

        }
    }

    getNextAppointments() {
        this.recentAppIndex = this.recentAppIndex + 2;
        if (this.recentAppIndex < this.dashboardReports.appointments.length) {
            this.appointmentsFiltered = this.dashboardReports.appointments.slice(this.recentAppIndex, this.recentAppIndex + 2);
        }

        if (this.dashboardReports.appointments.length % 2 == 0) {
            this.reportsLength = this.dashboardReports.appointments.length - 2;
        }
        else {
            this.reportsLength = this.dashboardReports.appointments.length - 1;
        }
    }

    filterAppointments() {
        this.appointmentsFiltered = [];
        if (this.dashboardReports.appointments != null) {
            this.appointmentsFiltered = this.dashboardReports.appointments.slice(this.recentAppIndex, 2);
        }
    }
    PatientSearch() {        
        if (this.patientId == "" || this.patientId == undefined || this.patientId == null) {
            this.IsPatientSearch = true;
            this.errMsg = "Please enter the required mandatory(*) filed.";
        }
        else {            
            this.IsPatientSearch =false;
            this.getDashboardReports();
        }
    }
    getDashboardReports() {
        this.loading = true;
        if (this.IsAdminUser == true) {
            if (this.Querynumber != "" && this.Querynumber != undefined) {
                this.userData.pid = this.Querynumber;
            }
            else
            {
                this.userData.pid = this.patientId;
            }

        }
        else {
            this.userData.pid = this._SecurityService.pid;
        }

            this._dashboardService.getDashboardData(this.userData.User, this.userData.Authentication, this.userData.pid, this.userData.IsAdminUser)
                .subscribe(
                p => {
                    if (p != null && p.ValidUser && p.SessionTimeout != "Session Expired") {
                        if (!p.IsSearchPatientValid)
                        {
                            this.IsPatientSearch = true;
                            this.errMsg = "Search Patient ID is not valid.";
                            this.loading = false;
                        }
                        else {
                            localStorage.setItem("AdminPatientId", this.patientId);
                            this.loading = false;
                            if (p.RecentAppointments == null) {
                                this.dashboardReports.appointments = [];
                            }
                            else {
                                this.dashboardReports.appointments = p.RecentAppointments;
                            }
                            this.dashboardReports.labReports = p.labReports;
                            this.dataSource = p.labReports;
                            this.buildGrid();
                            this.dashboardReports.userprofile = p.userprofile;
                            this.patientName = this.dashboardReports.userprofile.UserName;
                            localStorage.setItem("AdminPatientName", this.patientName);
                                
                            this.dashboardReports.newsAndPromotions = p.newsAndPromotions;
                            this.filterAppointments();
                            if (p.RecentAppointments == null) {
                                this.totalrecentApplength = 0;
                            }
                            else {
                                this.totalrecentApplength = this.dashboardReports.appointments.length;
                            }
                            this._SecurityService.errorMessage = "";
                            localStorage.setItem("BookingType", p.BookingType);
                            this.PaylaterStatus = p.PaylaterStatus;
                        }
                        
                    }
                    else if (!p.ValidUser || p.SessionTimeout == "Session Expired") {
                        this.loading = false;
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this.router.navigate(["/Login"]);
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting data...");
                }

                );
        
    }

    showCanelConfirmation(data) {
        if (this.IsAdminUser == true) {
            this._dashboardService.cancelAppointment(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser, data)
                .subscribe(
                s => {
                    if (s == "Success") {
                        this.message = "The booked slot has been Cancelled.";
                        this.viewModelPopup.open();
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting data...");
                });
        } else {
            this._dashboardService.cancelAppointment(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser, data)
                .subscribe(
                s => {
                    if (s == "Success") {
                        this.message = "The booked slot has been Cancelled.";
                        this.viewModelPopup.open();
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting data...");
                });
        }
        
    }

    closepopup() {
        this.viewModelPopup.close();
        if (this.IsAdminUser == true) {
            this.getDashboardReports();
        } else
        {
            window.location.reload();
        }       
    }


    public buildGrid() {
        try {
            this.buildColumn();

            var dgrid = jQuery("#grdDahboardApp").data("kendoGrid");
            if (dgrid) {
                $('#grdDahboardApp').data().kendoGrid.destroy();
                $('#grdDahboardApp').empty();
            }
            jQuery('#grdDahboardApp').kendoGrid({
                editable: false,
                filterable: true,
                pageable: {
                    pageSizes: [10, 25, 50, 100]
                },
                height: 400,
                scrollable: true,
                sortable: true,
                columns: this.columns,
                filterMenuInit: function (e) {
                    if (e.field != "SubmissionID" && e.field != "NameInsuredOrTreatyTitle") {
                        var filterMultiCheck = e.sender.thead.find("[data-field=" + e.field + "]").data("kendoFilterMultiCheck");
                        filterMultiCheck.container.empty();
                        var chkSourceData = filterMultiCheck.checkSource.data();

                        chkSourceData.sort(function (a: any, b: any) {
                            var sortStatus = 0;

                            if (a[e.field].toLowerCase() < b[e.field].toLowerCase()) {
                                sortStatus = -1;
                            } else if (a[e.field].toLowerCase() > b[e.field].toLowerCase()) {
                                sortStatus = 1;
                            }

                            return sortStatus;
                        });

                        filterMultiCheck.checkSource.data(chkSourceData.toJSON());
                        filterMultiCheck.createCheckBoxes();
                    }
                },
                dataBinding: this.databinding,

                dataSource: {
                    data: this.dataSource,
                    pageSize: this.dataSource != null ? 10 : 0,
                    sort: [{
                        field: "ProfitCenter",
                        dir: "asc"
                    }, {
                        field: "Department",
                        dir: "asc"
                    }, {
                        field: "Modified",
                        dir: "desc"
                    }],
                },
            });
            jQuery("#grdDahboardApp").data("kendoGrid").wrapper.children(".k-grid-pager").find("span.k-input").html('All');
            var gridPage = jQuery("#grdDahboardApp").data("kendoGrid");
            gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html('10');
            var pageSizeDropDownList = gridPage.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
            pageSizeDropDownList.bind("change", function (e: any) {
                gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html(gridPage.wrapper.children(".k-grid-pager").find("select").find('option:selected').text());
            });
        }
        catch (ex) {
            this.handleError(ex);
        }
    }

    buildColumn(): void {
        this.columns = [
            {
                field: "ReqNo",
                title: "Req No ",
            },
            {
                field: "TestName",
                title: "Test Name ",
            },
            {
                field: "DoctorName",
                title: "Doctor Name ",
            },

            {
                field: "Status",
                title: "Status ",
            }

        ];
    }

    buildLabReportRow(DOCTORNAME: string, VISITDATE: string, PAYMENTTYPE: string, VISITTYPE: string, PURPOSEOFVISIT: string): string {
        var line1 = "<div class='resultstablewrap'><div class='visit_wrap'><div class='doctor_date'>";
        var line2 = "<span> <strong>Dr.</strong> " + DOCTORNAME + "</span> <span class='pull-right'>";
        var line3 = "<i class='fa fa-calendar-check-o' aria- hidden='true'> </i> " + VISITDATE + " </span> </div>";
        var line4 = "<div class='resson_visit'><span><strong>Reason:</strong> " + PURPOSEOFVISIT + " </span>";
        var line5 = "<span class='pull-right'> <strong>Visit Type: </strong> " + VISITTYPE + " | <strong> Sponsor:</strong> " + PAYMENTTYPE + "</span></div></div></div>";
        return line1 + line2 + line3 + line4 + line5;
    }

    databinding(e: any) {
        try {
            var grid = jQuery("#grdDahboardApp").data("kendoGrid");
            var totalCount = grid.dataSource.total();
            var pageSizes = [{ text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "All", value: totalCount }];
            var pagerdropdownBox = jQuery('.k-pager-sizes select[data-role="dropdownlist"]').data('kendoDropDownList');
            var pagerds = new kendo.data.DataSource({
                data: pageSizes
            });
            pagerdropdownBox.setDataSource(pagerds);
        }
        catch (e) {
        }
    }

   


    private handleError(error: any) {
        console.log("error : " + error);
    }

    PayNowAppointmentRequest(item) {
        if (this.IsAdminUser == true) {
            this.loading = true;
            
            this._appointmentService.PayNowAppointmentRequest(this.userData.User, this.userData.Authentication, this.patientId, this.userData.IsAdminUser, item)
                .subscribe(
                s => {
                    if (s != null && s != "") {
                        window.location.href = s;
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting data...");
                });
        }
        else
        {
            this.loading = true;
            this._appointmentService.PayNowAppointmentRequest(this.userData.User, this.userData.Authentication, this.userData.pid, this.userData.IsAdminUser, item)
                .subscribe(
                s => {
                    if (s != null && s != "") {
                        window.location.href = s;
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting data...");
                });
        }
        
    }

    LoadingAfterPayment(Querynumber: string) {
        var userData: UserData = new UserData(this.userData.User, this.userData.Authentication, this.userData.pid, this._SecurityService.IsAdminUser);
        this._appointmentService.AfterPaymentConfirmation(Querynumber, userData)
            .subscribe(
            s => {
                if (s != null && s.isValid) {
                    this.LoadRecentAppointments();
                    this.IsBookingConfirmed = true;
                    this.payNowBookingPopup.open();
                }
                else {
                    this.IsBookingConfirmed = false;
                    this.payNowBookingPopup.open();
                }

            },
            err => {
                console.log("Error while getting data...");
            });
    }
    LoadMenusVisibility() {
        this._dashboardService.getMenuVisibility(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser)
            .subscribe(
            p => {
                this.navigation = p;
                for (var i = 0; i < p.length; i++) {
                    if (p[i].menuName == "APPOINTMENT REQUEST" && p[i].IsVisible == true) {
                        this.IsAppointmentVisible = true;
                    }
                    if (p[i].menuName == "SERVICE PAYMENT" && p[i].IsVisible == true) {
                        this.IsServiceVisible = true;
                    }
                    if (p[i].menuName == "ADVANCE PAYMENT" && p[i].IsVisible == true) {
                        this.IsAdvanceVisible = true;
                    }
                    if (p[i].menuName == "ALLERGY" && p[i].IsVisible == true) {
                        this.IsAllergyVisible = true;
                    }
                    if (p[i].menuName == "MEDICATIONS" && p[i].IsVisible == true) {
                        this.IsMedicationVisible = true;
                    }
                    if (p[i].menuName == "IMMUNIZATIONS" && p[i].IsVisible == true) {
                        this.IsImmunizationVisible = true;
                    }
                    if (p[i].menuName == "LAB RESULTS" && p[i].IsVisible == true) {
                        this.IsLabVisible = true;
                    }
                    if (p[i].menuName == "RADIOLOGY RESULTS" && p[i].IsVisible == true) {
                        this.IsRadiologyVisible = true;
                    }
                    if (p[i].menuName == "SCHEDULED APPOINTMENTS" && p[i].IsVisible == true) {
                        this.IsScheduleVisible = true;
                    }
                    if (p[i].menuName == "INSURANCE STATUS" && p[i].IsVisible == true) {
                        this.IsInsuranceVisible = true;
                    }
                    if (p[i].menuName == "DOCUMENTS" && p[i].IsVisible == true) {
                        this.IsDocuments = true;
                    }
                    if (p[i].menuName == "PROCEDURE RESULTS" && p[i].IsVisible == true) {
                        this.IsProcedureVisible = true;
                    }
                }
            },
            err => {
                console.log("Error while getting data...");
            });
    }
    payNowclosepopup() {
        this.payNowBookingPopup.close();
    }

    LoadRecentAppointments() {
        if (this.IsAdminUser == true) {
            this._dashboardService.dashboardRecentAppointments(this.userData.User, this.userData.Authentication, this.patientId, this.userData.IsAdminUser)
                .subscribe(
                p => {
                    if (p != null && p.ValidUser && p.SessionTimeout != "Session Expired") {
                        this.loading = false;
                        this.dashboardReports.appointments = p.RecentAppointments;
                        this._SecurityService.errorMessage = "";
                    }
                    else if (p.SessionTimeout == "Session Expired") {
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this.router.navigate(["/Login"]);
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting data...");
                });
        }
        else
        {
            this._dashboardService.dashboardRecentAppointments(this.userData.User, this.userData.Authentication, this.userData.pid, this.userData.IsAdminUser)
                .subscribe(
                p => {
                    if (p != null && p.ValidUser && p.SessionTimeout != "Session Expired") {
                        this.loading = false;
                        this.dashboardReports.appointments = p.RecentAppointments;
                        this._SecurityService.errorMessage = "";
                    }
                    else if (p.SessionTimeout == "Session Expired") {
                        this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                        this.router.navigate(["/Login"]);
                    }
                },
                err => {
                    this.loading = false;
                    console.log("Error while getting data...");
                });
        }
        
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/dashboard/Component/Dashboard.Component.ts